// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3k6xy","additionalInfo":"AgreementModal_additionalInfo__3-B46"};